import React, { useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { ErrorMessage } from "@hookform/error-message";
import { Typography } from "antd";

const TextAreaEditor = ({ label, errors, ...props }, ref) => {
    const modules = {
        toolbar: [
            ["bold", "italic", "underline", "strike"], // toggled buttons
            ["blockquote", "code-block"],
            ["link"],

            [{ list: "ordered" }, { list: "bullet" }],

            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            ["clean"], // remove formatting button
        ],
    };

    const formats = [
        "header",
        "font",
        "size",
        "bold",
        "italic",
        "underline",
        "strike",
        "blockquote",
        "list",
        "bullet",
        "indent",
        "link",
        "image",
        "color",
        "background",
        "align",
        "code-block",
    ];

    return (
        <div>
            {label && <Typography.Title level={5}>{label}</Typography.Title>}
            <ReactQuill
                theme="snow"
                {...props}
                modules={modules}
                formats={formats}
                placeholder="Enter text..."
            />
            {errors && (
                <ErrorMessage
                    errors={errors}
                    name={props.name}
                    render={(data) => (
                        <Typography.Text type="danger">
                            * {data.message}
                        </Typography.Text>
                    )}
                />
            )}
        </div>
    );
};

export default React.forwardRef(TextAreaEditor);
